// extracted by mini-css-extract-plugin
export default {"parent":"UserEditProfilePopup_parent__Q9H6N","cont":"UserEditProfilePopup_cont__u7ig3","child":"UserEditProfilePopup_child__6oLPw","profile":"UserEditProfilePopup_profile__TSH85"};